const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const getVisaNotesUrl = (applicationId, role) => {
  switch (role) {
    case 'super_admin':
      return `${API_URL}/super-admin/visa-applications/${applicationId}/visa-notes`;
    case 'manager':
      return `${API_URL}/manager/visa-applications/${applicationId}/visa-notes`;
    case 'airlines_admin':
      return `${API_URL}/visa-applications/${applicationId}/visa-notes`;
    case 'airlines_manager':
      return `${API_URL}/airlines-manager/visa-applications/${applicationId}/visa-notes`;
    default:
      return null;
  }
};
